import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from 'react-redux';
import { setIsLoading, setUserToken } from '../../../../../features/userSlice';
import { useState } from "react";
import { useDispatch } from 'react-redux';
import { MetaEntitiesEndPointLogic } from '../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic';
import SimpleBackdrop from '../../../../BackDrop/BackDrop';

interface OrganizationProps {
  open: boolean;
  handleClose: () => void;
}

function CreateOrganizationModal({
  open,
  handleClose,
}: OrganizationProps) {

  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [organizationName, setOrganizationName] = useState(null);
  const [organizationNumber, setOrganizationNumber] = useState(null);
  const [keeperFolderID, setKeeperFolderID] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const CreateOrganizationData = async() => {
    const data = {
      name: organizationName,
      organization_number: organizationNumber, 
      keeper_folder_id: keeperFolderID,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if(oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.createMetaOrganizations(oauthTokenHeader, data);
      } else {
        throw new Error("User doesn't have permissions to edit Organization");
      }
      if(oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaOrganizations(oauthTokenHeader,dispatch);
      }
    } catch(error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      setOrganizationName(null);
      setOrganizationNumber(null);
      setKeeperFolderID(null);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaOrganizations(oauthTokenHeader,dispatch);
    }
  }

  const handleCancel = () => {
    handleClose();
    setOrganizationName(null);
    setOrganizationNumber(null);
    setKeeperFolderID(null);
  }

  return (
    <>
      {loading ? (<SimpleBackdrop/>):(
        <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            Create New Organization
          </DialogTitle>
          <Typography sx={{mb:1}}>Details</Typography>
          <Grid container mt={0} columnSpacing={3}>
            <Grid item xs={6}>
              <TextField
                value={organizationName}
                onChange={(e:any) => setOrganizationName(e.target.value)}
                id="outlined-multiline-flexible"
                label="Organization Name *" // Set your label here
                placeholder="Enter unique Organization Name" // Set your placeholder here
                color="secondary"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={organizationNumber}
                onChange={(e:any) => setOrganizationNumber(e.target.value)}
                id="outlined-multiline-flexible"
                label="Organization Number *" // Set your label here
                placeholder="Enter Organization Number" // Set your placeholder here
                color="secondary"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={6} sx={{mt:2}}>
              <TextField
                value={keeperFolderID}
                onChange={(e:any) => setKeeperFolderID(e.target.value)}
                id="outlined-multiline-flexible"
                label="Keeper Folder ID *" // Set your label here
                placeholder="Please Type with care" // Set your placeholder here
                color="secondary"
                size="small"
                fullWidth
              />
            </Grid>
          </Grid>
          <Typography
            sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
          >
            All fields are mandatory.
          </Typography>
  
          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" onClick={handleCancel} sx={{mr:1}}>
              CANCEL
            </Button>
            <Button
             variant="contained"
             color="secondary"
             data-tracker="237"
             disabled={!organizationName || !organizationNumber || !keeperFolderID} 
             onClick={CreateOrganizationData}>
              Create <DoneIcon sx={{ml:1}} />
            </Button>
          </Stack>
        </Paper>
      </Dialog>
      )}
    </>
  );
}

export default CreateOrganizationModal;
